import AsyncStorage from '@react-native-async-storage/async-storage';

export const setToken = async (value) =>
  AsyncStorage.setItem('secure_token', value)
    .then(() => true)
    .catch((err) => err);

export const getToken = async () =>
  AsyncStorage.getItem('secure_token')
    .then((value) => value)
    .catch((err) => err);

export const deleteToken = async () =>
  AsyncStorage.removeItem('secure_token')
    .then(() => true)
    .catch((err) => err);
